module.exports = __webpack_public_path__ + "static/img/yiyun.b3aae012.png";